import type {GetTestOccurrenceTreeApiArg} from '../../../../../services/rest'
import {requestTestOccurrenceTreeOptions} from '../../../../packages/Tests/TestsTree/TestsTree.consts'

export const getProjectInvestigationsTabTreeArg = (
  locator: string,
): GetTestOccurrenceTreeApiArg => ({
  endpoint: 'testScopes/tree',
  locator,
  options: requestTestOccurrenceTreeOptions,
  treeLocator: locator,
})
